<t4-header icon="glyphicon-stats" title="{{'TO.Settings.UserManagement' | translate : 'User management' }}">
  <button mat-button color="primary" matTooltip="{{'T4.Settings.UserManagement.CreateUser' | translate : 'Create user' }}" (click)="newUser()"><mat-icon>note_add</mat-icon>{{'T4.Settings.UserManagement.CreateUser' | translate : 'Create user' }}</button>
</t4-header>
<t4-container>
  <mat-tab-group dynamicHeight="true">

    <mat-tab label="{{ 'T4.Settings.ManageCategories.lblUsers' | translate : 'Users' }}">
      <div class="searchUser">
        <div>
          <h1>{{ 'T4.Settings.ManageCategories.lblFindUser' | translate : 'Find user' }}</h1>
          <mat-form-field style="max-width: 900px;" appearance="outline">
            <input matInput placeholder="{{ 'Turbo.Settings.RightsManagement.SearchForUser' | translate : 'Search for user' }}" [matAutocomplete]="userAC" [formControl]="txtUser">
            <mat-spinner matSuffix *ngIf="isLoading" mode="indeterminate" diameter="25"></mat-spinner>
            <mat-autocomplete #userAC="matAutocomplete">
              <mat-option *ngFor="let item of filteredUsers | async" [value]="(item.Username ? item.Username  : '') + ' - ' + (item.Email ? item.Email  : '') + ' - ' + (item.Phone ? item.Phone  : '')" (onSelectionChange)="selectUser(item)">
                <span *ngIf="item.Username">{{item.Username}} - </span><span *ngIf="item.Email">{{item.Email}} - </span><span *ngIf="item.Phone">{{item.Phone}}</span>
              </mat-option>
            </mat-autocomplete>
          </mat-form-field>
        </div>
      </div>

      


      <mat-tab-group dynamicHeight="true" *ngIf="selectedUser">
        <mat-tab label="{{ 'Turbo.Settings.RightsManagement.GeneralSettings' | translate : 'General settings' }}">
          <div class="users">
            <EditUserComponent *ngIf="selectedUser" [user]="selectedUser"></EditUserComponent>
          </div>
        </mat-tab>
        <mat-tab label="{{ 'Turbo.Settings.RightsManagement.Rights' | translate : 'Rights' }}">
          <RightsManagementComponent *ngIf="selectedUser" [user]="selectedUser"></RightsManagementComponent>
        </mat-tab>
      </mat-tab-group>

    </mat-tab>

    <mat-tab label="{{ 'Turbo.Settings.Groups' | translate : 'Groups' }}">
      <div class="selectGroup">
        <h1>{{ 'Turbo.Settings.ChooseGroup' | translate : 'Choose group' }}</h1>
        <mat-form-field appearance="outline">
          <mat-label>{{ 'Turbo.Settings.Groups' | translate : 'Groups' }}</mat-label>
          <mat-select [(ngModel)]="selectedRole" (selectionChange)="getUsersWithRole()">
            <mat-option *ngFor="let role of roles" [value]="role">
              {{role.Name}}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <mat-tab-group dynamicHeight="true">
        <mat-tab label="{{ 'T4.Settings.ManageCategories.lblUsers' | translate : 'Users' }}">
          <div class="groupUsers">
            <h1><span style="display: inline-block; width: 73px"></span>{{ 'Turbo.Settings.UsersInGroup' | translate : 'Users in group' }}</h1>

            <t4-data-table #usersInRoleTbl [rawData]="usersInRole" [isLoadingData]="loading" headline="" matSort [allowPaging]="false" [allowFilter]="true" [filterFields]="['Username', 'Email']" [autoGenerateColumns]="false" searchText="{{ 'Turbo.Settings.RightsManagement.SearchForUser' | translate : 'Search for user' }}" searchAppearance="outline" [allowAdd]="true" (addClicked)="addUserToRole()">
              <ng-container matColumnDef="Id" *ngIf="false">
                <mat-header-cell *matHeaderCellDef mat-sort-header style="max-width: 75px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;"></mat-header-cell>
                <mat-cell *matCellDef="let row" style="max-width: 75px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">
                  <button mat-icon-button (click)="openUserEditor(row)">
                    <mat-icon>create</mat-icon>
                  </button>
                </mat-cell>
              </ng-container>
              <ng-container matColumnDef="Username">
                <mat-header-cell *matHeaderCellDef mat-sort-header style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; min-width:150px;">{{ 'Turbo.Settings.RightsManagement.UserName' | translate : 'Username' }}</mat-header-cell>
                <mat-cell *matCellDef="let row" style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; min-width:150px;">{{ row.Username }}</mat-cell>
              </ng-container>
              <ng-container matColumnDef="Email">
                <mat-header-cell *matHeaderCellDef mat-sort-header style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; min-width:150px;">{{ 'Turbo.Settings.RightsManagement.Email' | translate : 'Email' }}</mat-header-cell>
                <mat-cell *matCellDef="let row" style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; min-width:150px;">{{ row.Email }}</mat-cell>
              </ng-container>
              <ng-container matColumnDef="Edit">
                <mat-header-cell *matHeaderCellDef mat-sort-header style="max-width: 150px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">{{ 'Turbo.Settings.RightsManagement.EditUser' | translate : 'Edit user' }}</mat-header-cell>
                <mat-cell *matCellDef="let row" style="max-width: 130px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">
                  <button mat-icon-button (click)="editUser(row)" *ngIf="!row.IsActive">
                    <mat-icon>create</mat-icon>
                  </button>
                </mat-cell>
              </ng-container>
              <ng-container matColumnDef="Delete">
                <mat-header-cell *matHeaderCellDef mat-sort-header style="max-width: 150px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">{{ 'Turbo.Settings.RightsManagement.RemoveFromGroup' | translate : 'Remove from group' }}</mat-header-cell>
                <mat-cell *matCellDef="let row" style="max-width: 130px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">
                  <button mat-icon-button (click)="removeRoleFromUser(row)" *ngIf="!row.IsActive">
                    <mat-icon>delete</mat-icon>
                  </button>
                </mat-cell>
              </ng-container>
            </t4-data-table>
          </div>
        </mat-tab>
        <mat-tab label="{{ 'Turbo.Settings.RightsManagement.Rights' | translate : 'Rights' }}">
          <RightsManagementComponent *ngIf="selectedRole" [role]="selectedRole"></RightsManagementComponent>
        </mat-tab>
      </mat-tab-group>

    </mat-tab>
  </mat-tab-group>
</t4-container>

